<template>
    <div class="loading_wrapper">
        <LoadingIndicator class="primary big"></LoadingIndicator>
    </div>
</template>

<script>
    // @ is an alias to /src
    import CheckBox from '@/components/checkbox/CheckBox.vue'
    import axios from 'axios';
    import lStorage from '../../store/localStorage.js';
    import Cookie from '@/store/cookie.js';
    import env from '../../enviroment';
    import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';

    export default {
        name: 'DevelopmentLoginPage',
        components: {
            CheckBox,
            LoadingIndicator
        },
        data: function(){
            return {
                loading: false,
            }
        },
        mounted(){
            this.auth();
        },
        methods: {
            auth:function(){
                rest.call("development_login",{},"POST").then((response)=>{
                    if(response.token){
                        lStorage.set('auth-token', response.token);
                        Cookie.set("auth-token",response.token,{
                            "max-age":3600*30,
                            "domain":"."+env.domain
                        });
                        this.$router.push({
                            name:"lesson",
                            params:{
                                locale:i18n.locale,
                            }
                        });
                    }
                }).catch((error)=>{
                    this.$router.push({
                        name:"LoginPage",
                        params:{
                            locale:i18n.locale,
                        }
                    });
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .loading_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100%;
    }
</style>